import { createAction } from 'redux-actions';

export const requestCalendarStats = createAction('REQUEST/CALENDAR_STATS');
export const setCalendarFiltersAction = createAction('SET/CALENDAR_FILTERS');
